module.exports = __webpack_public_path__ + "media/images/konintodoke/diagnosis/kossori_kanji-f2f30f73c1b26f4326f4cbeca515d080.png";